module.exports = __webpack_public_path__ + "img/calendar.596475d6.svg";